import "@ant-design/v5-patch-for-react-19";

import React from "react";
import ReactDOM from "react-dom/client";
import "../src/i18n/i18n";

import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://2464663e25ef705fe8e0ed84b08d53ec@o281716.ingest.us.sentry.io/4508757223866368",
  integrations: [
    // Sentry.browserTracingIntegration(),
    // Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0,
  tracePropagationTargets: ["localhost", /^https:\/\/visitwidget\.com\/api/],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

import { App } from "../src/components/layout/App/App";
import { store } from "@store/store";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
